import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="Refresh_svg__lucide Refresh_svg__lucide-refresh-cw-icon Refresh_svg__lucide-refresh-cw"
    xmlns="http://www.w3.org/2000/svg"
    strokeLinejoin="round"
    stroke="currentColor"
    strokeLinecap="round"
    viewBox="0 0 24 24"
    strokeWidth={2}
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
    <path d="M21 3v5h-5M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
    <path d="M8 16H3v5" />
  </svg>
);
export default SvgRefresh;
